import { render, staticRenderFns } from "./QuestionAndAnswer.vue?vue&type=template&id=ecf7a7ea&scoped=true&"
import script from "./QuestionAndAnswer.vue?vue&type=script&lang=js&"
export * from "./QuestionAndAnswer.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAndAnswer.vue?vue&type=style&index=0&id=ecf7a7ea&prod&lang=scss&scoped=true&"
import style1 from "./QuestionAndAnswer.vue?vue&type=style&index=1&id=ecf7a7ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf7a7ea",
  null
  
)

export default component.exports